
import React from 'react';
import { Button } from "@/components/ui/button";

interface CoachingPricingProps {
  title?: string;
  price?: number;
  duration?: string;
  isInitiatingPayment: boolean;
  onBookNow: () => void;
}

const CoachingPricing = ({ 
  title = "Coaching Session",
  price = 199,
  duration = "60-minute one-on-one session",
  isInitiatingPayment, 
  onBookNow 
}: CoachingPricingProps) => {
  return (
    <div className="bg-card p-6 rounded-lg border">
      <h3 className="text-xl font-semibold mb-2">{title}</h3>
      <p className="text-2xl font-bold mb-1">${price}</p>
      <p className="text-sm text-muted-foreground mb-4">{duration}</p>
      <Button 
        className="w-full" 
        size="lg"
        onClick={onBookNow}
        disabled={isInitiatingPayment}
      >
        {isInitiatingPayment ? "Processing..." : "Book Now"}
      </Button>
    </div>
  );
};

export default CoachingPricing;
